import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ kind: "idle", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ kind: "loading", message: "" });
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      if (data.status === "already_subscribed") {
        setStatus({ kind: "ok", message: "Vous êtes déjà inscrit·e." });
      } else {
        setStatus({ kind: "ok", message: "Merci. Votre inscription est confirmée." });
        setEmail("");
      }
    } catch (err) {
      setStatus({ kind: "error", message: formatApiErrorDetail(err.response?.data?.detail) });
    }
  };

  return (
    <footer
      className=""
      style={{ background: "#000000", borderTop: "1px solid #1c1c1c" }}
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          <div className="md:col-span-5">
            <p className="label mb-8">La lettre</p>
            <h3 className="font-serif text-4xl md:text-5xl leading-[1.05] mb-8" style={{ color: "#F8F6F0" }}>
              Recevez les annonces officielles en avant-première.
            </h3>
            <form onSubmit={submit} className="max-w-md" data-testid="newsletter-form">
              <label htmlFor="nl-email" className="label block mb-3">
                Votre adresse
              </label>
              <div className="flex items-end gap-6">
                <input
                  id="nl-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="prenom.nom@exemple.fr"
                  className="input-editorial"
                  data-testid="newsletter-email-input"
                />
                <button
                  type="submit"
                  className="label shrink-0 pb-4"
                  style={{ color: "#C9A961", borderBottom: "1px solid #C9A961" }}
                  disabled={status.kind === "loading"}
                  data-testid="newsletter-submit"
                >
                  {status.kind === "loading" ? "Envoi…" : "S'inscrire"}
                </button>
              </div>
              {status.message && (
                <p
                  className="label mt-4"
                  style={{ color: status.kind === "error" ? "#C9A961" : "#A1A1AA" }}
                  data-testid="newsletter-status"
                >
                  {status.message}
                </p>
              )}
            </form>
          </div>

          <div className="md:col-span-2">
            <ul className="space-y-4" style={{ color: "#F8F6F0", marginTop: "calc(1rem + 32px)" }}>
              <li><Link to="/home" className="link-editorial">Accueil</Link></li>
              <li><Link to="/nominations" className="link-editorial">Nominations</Link></li>
              <li><Link to="/spectacles" className="link-editorial">Spectacles</Link></li>
              <li><Link to="/bibliotheque" className="link-editorial">Bibliothèque</Link></li>
              <li><Link to="/jury" className="link-editorial">Jury</Link></li>
              <li><Link to="/trophees" className="link-editorial">Trophées</Link></li>
              <li><Link to="/voter" className="link-editorial">Voter</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <ul className="space-y-4" style={{ color: "#F8F6F0", marginTop: "calc(1rem + 32px)" }}>
              <li><Link to="/manifeste" className="link-editorial">Manifeste</Link></li>
              <li><Link to="/ceremonie" className="link-editorial">Cérémonie</Link></li>
              <li><Link to="/archives" className="link-editorial">Archives</Link></li>
              <li><Link to="/presse" className="link-editorial">Presse</Link></li>
              <li><Link to="/partenaires" className="link-editorial">Partenaires</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="label mb-8">Réseaux</p>
            <div className="flex flex-col gap-4" style={{ color: "#F8F6F0" }}>
              <a className="link-editorial" href="https://instagram.com/lestanddor" rel="noopener noreferrer" target="_blank">INSTAGRAM</a>
              <a className="link-editorial" href="https://tiktok.com/@lestanddor" rel="noopener noreferrer" target="_blank">TIKTOK</a>
              <a className="link-editorial" href="https://youtube.com/@lestanddor" rel="noopener noreferrer" target="_blank">YOUTUBE</a>
              <a className="link-editorial" href="https://twitch.tv/lestanddor" rel="noopener noreferrer" target="_blank">TWITCH</a>
            </div>
            <p className="label mt-12" style={{ color: "#A1A1AA" }}>Contact presse</p>
            <p className="mt-3" style={{ color: "#F8F6F0" }}>presse@lestanddor.com</p>
          </div>
        </div>

        <div className="hairline mt-24" />

        <div className="pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="label" style={{ color: "#A1A1AA" }}>
            © 2026 Le Stand d'Or — Tous droits réservés
          </p>
          <div className="flex gap-8">
            <Link to="/mentions-legales" className="label" style={{ color: "#A1A1AA" }}>Mentions légales</Link>
            <Link to="/admin/login" className="label" style={{ color: "#A1A1AA" }} data-testid="footer-admin-link">Espace privé</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
